import Reflux from 'reflux';

const NotificationsActions = Reflux.createActions({
  delete: { asyncResult: true },
  list: { asyncResult: true },
});

export default NotificationsActions;



// WEBPACK FOOTER //
// ./src/actions/notifications/NotificationsActions.jsx